export default __webpack_public_path__ + "static/media/telegram.570d7223.svg";